import { appConfig } from '@config/app.config';
import { gameBalance } from '@config/gameBalance';

export interface GridSlot {
  x: number;
  y: number;
}

/** Grid banknot pozisyonlarını hesaplar */
export function computeGridSlots(): GridSlot[] {
  const cols = gameBalance.gridColumns;
  const rows = gameBalance.gridRows;
  const noteWidth = gameBalance.gridBanknoteWidth;
  const noteHeight = gameBalance.gridBanknoteHeight;
  const gapX = gameBalance.gridGapX;
  const gapY = gameBalance.gridGapY;

  const totalWidth = cols * noteWidth + (cols - 1) * gapX;
  const totalHeight = rows * noteHeight + (rows - 1) * gapY;
  const startX = (appConfig.gameWidth - totalWidth) / 2 + noteWidth / 2;
  const startY = (appConfig.gameHeight - totalHeight) / 2 + 60 + noteHeight / 2;

  const slots: GridSlot[] = [];

  for (let index = 0; index < gameBalance.gridSize; index += 1) {
    const col = index % cols;
    const row = Math.floor(index / cols);
    slots.push({
      x: startX + col * (noteWidth + gapX),
      y: startY + row * (noteHeight + gapY),
    });
  }

  return slots;
}

export const previewBanknotePosition = {
  x: appConfig.gameWidth / 2,
  y: appConfig.gameHeight / 2 + 40,
} as const;

export const previewDimensions = {
  width: gameBalance.previewBanknoteWidth,
  height: gameBalance.previewBanknoteHeight,
} as const;

export const gridDimensions = {
  width: gameBalance.gridBanknoteWidth,
  height: gameBalance.gridBanknoteHeight,
} as const;
